"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.sliceReducer = void 0;
// (C) 2021-2022 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var rootReducers_1 = require("./rootReducers");
var state_1 = require("./state");
var attributeFilterSlice = toolkit_1.createSlice({
    name: "attributeFilterSlice",
    // Missing properties are provided in preloadedState in createStore
    initialState: state_1.initialState,
    reducers: rootReducers_1.rootReducers,
});
/**
 * @internal
 */
exports.sliceReducer = attributeFilterSlice.reducer;
/**
 * @internal
 */
exports.actions = attributeFilterSlice.actions;
//# sourceMappingURL=slice.js.map